import React from 'react';
import { Scale, Phone } from 'lucide-react';
export function Header() {
  return <header className="sticky top-0 z-50 w-full bg-white border-b border-slate-200 shadow-sm" data-id="element-187" data-mp="2dm4h6dqijsz0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-188" data-mp="2ilh757colg5t">
        <div className="flex justify-between items-center h-20" data-id="element-189" data-mp="2ik61t33l80cl">
          {/* Logo */}
          <div className="flex items-center gap-3" data-id="element-190" data-mp="2nm53m8joip7f">
            <div className="bg-brand-900 p-2 rounded-lg" data-id="element-191" data-mp="2rmfd3v6ojxr1">
              <Scale className="w-6 h-6 text-brand-accent" data-id="element-192" data-mp="2rlvu0b5an3bf" />
            </div>
            <div className="flex flex-col" data-id="element-193" data-mp="2wjxjpex860vv">
              <span className="font-serif font-bold text-xl leading-tight text-brand-900" data-id="element-194" data-mp="31byt8t30ddi7">
                California
              </span>
              <span className="text-xs font-semibold tracking-widest text-brand-600 uppercase" data-id="element-195" data-mp="36a0ar9ksd4rk">
                Mesothelioma Claims
              </span>
            </div>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-6" data-id="element-196" data-mp="3fc9lo0jyv05h">
            <a href="#why-us" className="text-sm font-medium text-slate-600 hover:text-brand-900 transition-colors" data-id="element-197" data-mp="2wldwjoicb39r">
              Why Us
            </a>
            <a href="#results" className="text-sm font-medium text-slate-600 hover:text-brand-900 transition-colors" data-id="element-198" data-mp="2mm54j171byq1">
              Results
            </a>
            <a href="#calculator" className="text-sm font-medium text-slate-600 hover:text-brand-900 transition-colors" data-id="element-199" data-mp="3fb2jovfy9fek">
              Calculator
            </a>
            <a href="#exposure-sites" className="text-sm font-medium text-slate-600 hover:text-brand-900 transition-colors" data-id="element-200" data-mp="35l0x6838w51r">
              Exposure Sites
            </a>
            <a href="#resources" className="text-sm font-medium text-slate-600 hover:text-brand-900 transition-colors" data-id="element-201" data-mp="1wpguf344q4m">
              Resources
            </a>
            <a href="#faq" className="text-sm font-medium text-slate-600 hover:text-brand-900 transition-colors" data-id="element-202" data-mp="1rdbbemujwyqn">
              FAQ
            </a>

            <a href="tel:805-770-9317" className="flex items-center gap-2 bg-brand-900 hover:bg-brand-800 text-white px-5 py-2.5 rounded-md font-semibold transition-all shadow-md hover:shadow-lg" data-id="element-203" data-mp="1ho9xd27kgrfb">
              <Phone className="w-4 h-4 text-brand-accent" data-id="element-204" data-mp="18lijywv4rll1" />
              <span data-id="element-205" data-mp="1cp6sbhrl6l7c">(805) 770-9317</span>
            </a>
          </nav>

          {/* Mobile CTA */}
          <div className="lg:hidden flex items-center" data-id="element-206" data-mp="ypp7telbpu3s">
            <a href="tel:805-770-9317" className="flex items-center gap-2 bg-brand-900 text-white px-4 py-2 rounded-md font-semibold text-sm" data-id="element-207" data-mp="yr08v6ndwnr7">
              <Phone className="w-4 h-4 text-brand-accent" data-id="element-208" data-mp="2t3q3xrpho306" />
              <span data-id="element-209" data-mp="2y29uk5f122yv">Call Now</span>
            </a>
          </div>
        </div>
      </div>
    </header>;
}